import $ from "jquery";
import LazyLoad from "vanilla-lazyload";

var myLazyLoad = new LazyLoad({
  elements_selector: ".lazy",
});

if ($("html").hasClass("mobile")) {
  window.onload = function () {
    var clean_phone = $("header address p").text().replace(/\D/g, "");
    $(".rd-mobilepanel .rd-mobilepanel_title").html(
      '<a class="btn btn-red btn-sm" href="tel:' +
        clean_phone +
        '"> <i class="fa fa-phone"></i> ' +
        $("header address p").text() +
        "</a>"
    );
  };
}

$(".location_block_link").click(function () {
  console.log("ereee");
  var link_id = $(this).attr("data-scroll");
  console.log(link_id);
  to_position("#" + link_id);
  return false;
});

function to_position(divid) {
  $("html, body").animate(
    {
      scrollTop: $(divid).position().top + 30,
    },
    "slow"
  );
}

if (typeof Stripe !== "undefined") {
  // Replace with your own publishable key: https://dashboard.stripe.com/test/apikeys
  var PUBLISHABLE_KEY =
    "pk_live_51HNjD1GPjGmDimMUIeWOVUeB8roEedbQKeUvA8Z8P93fLlqYO0dMGlnLaRLSRJyCnWfKUdbk5MkOe7DKN29Fb2iE00n8Egldth";
  // var PUBLISHABLE_KEY = "pk_test_51HNjD1GPjGmDimMUymFv3RMuQFRIRfVHevx3AVXVEsbAuPHM14eRkCMpIKXQ6MIRkT2AXYC0Y1pEnGSww0kpa04O006Se4Oakf";//test
  // Replace with the domain you want your users to be redirected back to after payment
  var DOMAIN = window.location.origin;
  var stripe = Stripe(PUBLISHABLE_KEY);
  var basicPhotoButton = document.getElementById("basic-photo-button");

  // Handle any errors from Checkout
  var handleResult = function (result) {
    if (result.error) {
      var displayError = document.getElementById("error-message");
      displayError.textContent = result.error.message;
    }
  };

  $(".register_class").each(function (i, obj) {
    var btn_id = $(obj).attr("id");
    var basicPhotoButton = document.getElementById(btn_id);
    basicPhotoButton.addEventListener("touchstart", payment_handler, false);
    basicPhotoButton.addEventListener("click", payment_handler, false);

    function payment_handler() {
      stripe
        .redirectToCheckout({
          mode: "payment",
          lineItems: [{ price: btn_id, quantity: 1 }],
          successUrl:
            DOMAIN +
            "/thank-you-driving-lesson?session_id={CHECKOUT_SESSION_ID}",
          cancelUrl: DOMAIN + "/live-traffic-courses/driving-lesson-packages",
        })
        .then(handleResult);
    }
  });
}
